import { Home as HomeIcon } from 'lucide-react';
import { useAuthUser } from 'react-auth-kit';
import User from '../Models/User';
import AppLayout from '../Layout/AppLayout';
import { PageHeader } from '../Components/ui';

const Home = () => {
    const auth = useAuthUser();
    const user: User = JSON.parse(JSON.stringify(auth() || {}));

    return (
        <AppLayout>
            <PageHeader
                icon={<HomeIcon />}
                title={`Bienvenue, ${user?.Name?.split(' ')[0] || ''}`}
                subtitle="Utilisez le menu latéral pour accéder aux différents modules de eBCall"
            />
        </AppLayout>
    );
};

export default Home;
